// extracted by mini-css-extract-plugin
export var createdDate = "_nd-1";
export var divider = "_nd-2";
export var headerDivider = "_nd-3";
export var messagesCard = "_nd-0";
export var messagesContainer = "_nd-6";
export var messagesContainerWrapper = "_nd-4";
export var showLeftPanelButton = "_nd-8";
export var topButtons = "_nd-7";
export var withPadding = "_nd-5";